import { createContext } from 'react';

import { createI18nFn } from 'i18n/createI18nFn';
import type { I18nFn } from 'i18n/types/I18nFn';
import { I18nLocale } from 'i18n/types/I18nLocale';

export const I18nContext = createContext<{ locale: I18nLocale; i18n: I18nFn }>({
  locale: I18nLocale.EN,
  i18n: createI18nFn(I18nLocale.EN),
});
